import * as types from 'store/mutation-types'
import Vue from 'vue'

const state = {
  US: {
    today: {},
    etf: {},
    special: {}
  },
  HK: {
    today: {},
    special: {}
  },
  CN: {
    today: {},
    special: {}
  },
  market: 'US',
  category: 'today',
  sidebarListId: null,
  currentDate: '',
  filter: {
    aConnectFilter: null,
    hkUnFilter: null,
    usUnFilter: null,
    usMarketFilter: null
  }
}

const getters = {
  discoveryData(state) {
    const market = state.market
    const category = state.category
    const data = []
    if (market && data) {
      Object.keys(state[market][category]).map(val => {
        if (state[market][category][val]) {
          data.push(state[market][category][val])
        }
      })
    }
    return data
  },
  discoverySideList(state) {
    const market = state.market
    const category = state.category
    const displayStore = state[market][category]
    const list = {
      items: null
    }
    if (state.sidebarListId) {
      const key = Object.keys(displayStore).filter(val => {
        if (displayStore[val]) {
          return displayStore[val].id === state.sidebarListId
        }
        return false
      })[0]
      if (key) {
        list.name = displayStore[key].name
        list.id = displayStore[key].id
        list.items = displayStore[key].items
        list.market = state.market
        list.category = state.category
      }
    }
    return list
  },
  discoveryFilter(state) {
    return state.filter
  }
}

const mutations = {
  [types.LOAD_DISCOVERY_DATA](state, data) {
    const category = data.category
    Object.keys(data).map(key => {
      if (key === 'category') {
        state[key] = data[key]
      } else if (key === 'market') {
        state[key] = data[key]
      } else {
        Vue.set(state[data.market][category], [key], data[key])
      }
    })
  },
  [types.CLEAR_DISCOVERY_DATA](state) {
    const market = state.market
    const category = state.category
    Object.keys(state[market][category]).map(val => {
      state[market][category][val] = null
    })
    state.sidebarListId = null
  },
  [types.SET_DISCOVERY_SIDE_LIST](state, id) {
    state.sidebarListId = id
  },
  [types.UPDATE_CURRENT_DATE](state, currentDate) {
    state.currentDate = currentDate
  },
  [types.SET_DISCOVEY_FILTERS](state, data) {
    for (const item in data) {
      Vue.set(state.filter, [item], data[item])
    }
  }
}

const actions = {
  clearDiscoveryData({ commit }, category) {
    commit(types.CLEAR_DISCOVERY_DATA, category)
  },
  setDiscoverySidebarList({ commit }, listId) {
    commit(types.SET_DISCOVERY_SIDE_LIST, listId)
  },
  loadDiscoveryData({ state, dispatch }, { market, category }) {
    if (category !== state.category) {
      dispatch('clearDiscoveryData', category)
    }
    const actionMap = {
      US: {
        today: 'loadUsTodayDiscovery',
        etf: 'loadUsEtfDiscovery',
        special: 'loadUsSpecialDiscovery'
      },
      HK: {
        today: 'loadHkTodayDiscovery',
        special: 'loadHkSpecialDiscovery'
      }
    }
    return new Promise((resolve, reject) => {
      const action = actionMap[market][category]
      dispatch(action, { market, category }).then(resp => {
        resolve()
      })
    })
  },
  updateDate({ commit }, currentDate) {
    commit(types.UPDATE_CURRENT_DATE, currentDate)
  },
  setDiscoveryFilter({ commit }, payload) {
    commit(types.SET_DISCOVEY_FILTERS, payload)
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
